const $inject = [
  "$scope",
  "$timeout",
  "Upload",
  "PharmacistService",
  "MessageService",
];

class DocumentationController {
  constructor(
    $scope,
    $timeout,
    ngFileUpload,
    PharmacistService,
    MessageService
  ) {
    // Components
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.ngFileUpload = ngFileUpload;
    /** @var {PharmacistService} */
    this.PharmacistService = PharmacistService;
    /** @var {MessageService} */
    this.MessageService = MessageService;

    //noinspection JSUnusedGlobalSymbols
    this.longLoad = false;

    this.loading = false;
    this.loaded = false;
    this.progress = null;

    $scope.uploaded_documents = {};
    $scope.today = new Date();
    $scope.today.setHours(0, 0, 0, 0);

    this.files = {
      hmrCertificate: {},
      ahpraCertificate: {},
      piPlCertificate: {},
    };

    this.viewValues = {
      hmrCertificate: null,
      ahpraCertificate: null,
      piPlCertificate: null,
    };

    this.updatePA = {
      updateSuccess: false,
      error: false,
      message: "",
    };

    this.get(false);
  }

  /**
   * Get pharmacist documents
   * @param {Boolean} forceRefresh
   */
  get(forceRefresh) {
    var self = this;

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.loading = false;
        self.pharmacist = response.data.data.account;
        for (let document of response.data.data.documents) {
          if (document.document_expiry) {
            document.document_expiry = new Date(document.document_expiry);
          }
          //noinspection JSUnresolvedReference
          self.$scope.uploaded_documents[document.accreditation_type.name] = document;
        }

        self.loaded = true;
      }
      else {
        handleError(response);
      }
    };

    //noinspection JSUnusedLocalSymbols
    var handleError = function (response) {
      self.loading = false;
    };

    this.loading = true;
    this.PharmacistService.get(handleSuccess, handleError, forceRefresh);
  }

  update(form) {
    this.submitted = true;

    var self = this;

    //set to true if loading is taking a while (10 secs)
    self.longLoad = false;

    var timer = self.$timeout(function () {
      self.longLoad = true;
    }, 10000);

    var stopTimer = function () {
      self.$timeout.cancel(timer);
      self.longLoad = false;
    };

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.loading = false;
        self.updatePA.updateSuccess = true;

        // Reload filenames
        self.get(true);

        self.files = {
          hmrCertificate: {},
          ahpraCertificate: {},
          piPlCertificate: {},
        };

        self.viewValues = {
          hmrCertificate: null,
          ahpraCertificate: null,
          piPlCertificate: null,
        };

        self.MessageService.add("success", "Thank you. Your documents have been uploaded. Please keep the documents in your profile up-to-date.");
        if (window.scrollTo) {
          window.scrollTo(0, 0);
        }
      }
      else {
        handleError(response);
      }
      stopTimer();
    };

    var handleError = function (response) {
      self.loading = false;
      self.updatePA.updateSuccess = false;
      self.updatePA.error = true;

      stopTimer();

      self.MessageService.add("danger", response.data.message);
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }
    };

    var handleProgress = function (event) {
      self.progress = Math.floor(100.00 * event.loaded / event.total);
    };

    if (form.$valid) {
      self.loading = true;
      //noinspection JSUnresolvedReference
      self.ngFileUpload.upload({
        url: "/app/pharmacist/updateAccreditation",
        data: {
          files: self.files,
        },
        disableProgress: false,
      }).then(handleSuccess, handleError, handleProgress);
    }
    else {
      stopTimer();
    }
  }

  /**
   * Get file name for the view
   * @param type
   * @param $file
   */
  displayName(type, $file) {
    if ($file) {
      this.viewValues[type] = $file.name;
    }
  }
}

DocumentationController.$inject = $inject;

export default DocumentationController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/controllers/documentation.controller.js
 **/